import React from 'react'
import cn from 'classnames'
import { currencyFullValue, percentageFormat, priceColor } from '../../core/helpers'
import { ReactComponent as BTC } from '../Icon/coins/btc.svg'
import { ReactComponent as ETH } from '../Icon/coins/eth.svg'
import { ReactComponent as BNB } from '../Icon/coins/bnb.svg'
import { ReactComponent as USD } from '../Icon/coins/usd.svg'

import Card from '../Card/Card'
import CardHead from '../Card/CardHead'
import Table from '../Table/Table'

function CoinPerformance({ isFetching, performance, priceRanges }) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
      <div>
        <Card className="h-full">
          <CardHead title="Price Range" />
          <div className="flex flex-col justify-between h-full pt-3">
            {isFetching ? <PerformanceSpinner /> : priceRanges.map(item => (
              <PerformanceChange
                className="mt-4 mb-2"
                key={item.type}
                range={item}
                type={item.type}
              />
            ))}
          </div>
        </Card>
      </div>

      <div>
        <Card>
          <CardHead title="Performance" />
          {isFetching ? <div className="pt-3"><PerformanceSpinner /></div> :
            <Table>
              <thead>
              <tr className="text-sm text-grey">
                <td className="pb-2 pt-2">VS</td>
                <td className="text-right pb-2 pt-2">1W</td>
                <td className="text-right pb-2 pt-2">1M</td>
              </tr>
              </thead>
              <tbody>
              {performance.map((data, index) => (
                <tr key={index}>
                  <td className="text-bran uppercase flex items-center">
                    <CoinIcon code={data.code} />{data.code}
                  </td>
                  <td className={cn('text-right', priceColor(data['1w']))}>
                    {percentageFormat(data['1w'], null, 0)}
                  </td>
                  <td className={cn('text-right', priceColor(data['1m']))}>
                    {percentageFormat(data['1m'], null, 0)}
                  </td>
                </tr>
              ))}
              </tbody>
            </Table>}
        </Card>
      </div>
    </div>
  )
}

function CoinIcon({ code }) {
  switch (code) {
    case 'btc':
      return <BTC className="mr-3" />
    case 'eth':
      return <ETH className="mr-3" />
    case 'bnb':
      return <BNB className="mr-3" />
    case 'usd':
      return <USD className="mr-3" />
    default:
      return ''
  }
}

function PerformanceChange({ className, range, type }) {
  return (
    <div className={className}>
      <div className="relative h-1 rounded-full" style={{ backgroundColor: '#1a1d24' }}>
        <div style={{ width: `${range.value}%`, backgroundColor: '#d9ff02' }}
             className="absolute h-full rounded-full transition-all"
             role="progressbar"
             aria-valuenow={range.value}
             aria-valuemin="0"
             aria-valuemax="100" />
      </div>
      <div className="flex justify-between mt-2">
        <small className="text-bran">
          {currencyFullValue(range.min, { thousandSeparated: true, mantissa: 4, optionalMantissa: true })}
        </small>
        <small className="text-grey">{type}</small>
        <small className="text-bran">
          {currencyFullValue(range.max, { thousandSeparated: true, mantissa: 4, optionalMantissa: true })}
        </small>
      </div>
    </div>
  )
}

function PerformanceSpinner() {
  return (
    <div className="text-center m-5">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white mx-auto" role="status" />
    </div>
  )
}

export default CoinPerformance
